module.exports = __webpack_public_path__ + "img/Eindhoven-FC.dfb1c9be.png";